/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import _ from 'lodash';
import i18next from 'i18next';

const state = {
  isLoading: false,
  currentUser: null,
  language: 'th',
};

const getters = {
  isLoading: state => state.isLoading,
  currentUser: state => state.currentUser,
  userLanguage: state => state.language,
};

const mutations = {
  setIsCurrentUserLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setCurrentUser(state, currentUser) {
    state.currentUser = _.cloneDeep(currentUser);
  },
  setUserLanguage(state, language) {
    state.language = language;
    i18next.changeLanguage(language);
  },
  destroyCurrentUser(state) {
    state.currentUser = {};
  },
};

const actions = {
  setCurrentUser({ commit }, currentUser) {
    commit('setCurrentUser', currentUser);
    commit('setIsCurrentUserLoading', false);
  },
  setUserLanguage({ commit }, language) {
    commit('setUserLanguage', language);
  },
  destroyCurrentUser({ commit }) {
    commit('destroyCurrentUser');
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
